import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ListingsPage from '@/pages/listings/page';
import PropertyDetailPage from '@/pages/listings/detail';
import DashboardPage from '@/pages/dashboard/page';
import ContactPage from '@/pages/contact/page';
import ComparePage from '@/pages/compare/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/listings', element: <ListingsPage /> },
  { path: '/listings/:id', element: <PropertyDetailPage /> },
  { path: '/dashboard', element: <DashboardPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/compare', element: <ComparePage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
